export function isValidFrenchVatNumber(value) {
  const normalized = String(value || "").trim().toUpperCase();
  const match = normalized.match(/^FR([0-9]{2})([0-9]{9})$/);

  if (!match) return false;

  const key = Number(match[1]);
  const siren = Number(match[2]);

  return key === (12 + 3 * (siren % 97)) % 97;
}

export function frenchVatError(value) {
  const normalized = String(value || "").trim().toUpperCase();

  if (!normalized) return "Requis";
  if (!/^FR[0-9]{11}$/.test(normalized)) {
    return "Format attendu : FR + 2 chiffres + 9 chiffres";
  }
  if (!isValidFrenchVatNumber(normalized)) return "Clé de contrôle invalide";

  return "";
}